import {Subject} from 'rxjs';

export const $module = new Subject<any>();